import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { DOWNLOAD_SURGE_SAMPLE_FILE, DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS, DOWNLOAD_SURGE_SAMPLE_FILE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* downloadSurgeSampleFile({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/data-integration/download-sample`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: DOWNLOAD_SURGE_SAMPLE_FILE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DOWNLOAD_SURGE_SAMPLE_FILE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DOWNLOAD_SURGE_SAMPLE_FILE_ERROR, payload: error });
  }
}

export function* watchdownloadSurgeSampleFile() {
  yield takeEvery(DOWNLOAD_SURGE_SAMPLE_FILE, downloadSurgeSampleFile);
}

function* downloadSurgeSampleFileSaga() {
  yield all([fork(watchdownloadSurgeSampleFile)]);
}

export default downloadSurgeSampleFileSaga;
